export const basicComponents = [
  {
    type: 'input',
    name: '单行文本',
    labelPosition: '',
    suffix: '',
    showName: true,
    icon: 'icon-input',
    options: {
      width: '100%',
      length: 50,
      defaultValue: '',
      required: false,
      hidden: false,
      disabled: false,
      dataType: 'string',
      pattern: '',
      placeholder: '请填写',
      customClass: '',
      customDesc: '',
      // 初始值 (添加初始值的组件：单行文本，多行文本,文本，子表单)
      initialValue: true,

      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
        cascaderVal: [],
        cascadeList: [],
      },
      remoteUrl: '', // 远端接口地址
      isShowSelect: true,
      queryData: {}, // 接口数据详情
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      // 事件选项
      eventType: null,
      eventObj: [], // 内置属性
    },
  },
  {
    type: 'textarea',
    name: '多行文本',
    showName: true,
    icon: 'icon-diy-com-textarea',
    options: {
      width: '100%',
      length: 100,
      defaultValue: '',
      required: false,
      hidden: false,
      disabled: false,
      pattern: '',
      placeholder: '请填写',
      customClass: '',
      customDesc: '',
      // 初始值
      initialValue: true,
      // 审批语
      approvalTipValue: false,
      ApprovalLanguage: [],
      languageList: [
        { value: '同意', key: 1 },
        { value: '不同意', key: 2 },
      ],

      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
        cascaderVal: [],
        cascadeList: [],
      },
      remoteUrl: '', // 远端接口地址
      isShowSelect: true,
      queryData: {}, // 接口数据详情
      displayInPage: false,
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      defaultRows: 5,
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'hidden',
    name: '隐藏域',
    showName: false,
    icon: 'sw-icon el-icon-view',
    options: {
      dataForm: 'fixed',
      defaultValue: '',
      randomFunc: '',
      remoteUrl: '',
      remoteKey: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
  {
    type: 'number',
    name: '计数器',
    showName: true,
    icon: 'icon-number',
    options: {
      width: '',
      required: false,
      defaultValue: 0,
      min: 0,
      max: 100,
      step: 1,
      disabled: false,
      hidden: false,
      stepStrictly: false,
      controlsPosition: '',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'radio',
    name: '单选框组',
    showName: true,
    icon: 'icon-radio-active',
    options: {
      inline: true,
      defaultValue: '',
      disabled: false,
      hidden: false,
      showLabel: false,
      options: [{ value: '选项1' }, { value: '选项2' }, { value: '选项3' }],
      required: false,
      width: '',
      optionType: 'static', //  static  dictionary  service
      dicTypeCode: { code: '', name: '', cache: true },
      remoteOptions: [],
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
      },
      remoteUrl: '', // 远端接口地址
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'checkbox',
    name: '多选框组',
    showName: true,
    icon: 'icon-check-box',
    options: {
      inline: true,
      defaultValue: [],
      disabled: false,
      hidden: false,
      showLabel: false,
      options: [{ value: '选项1' }, { value: '选项2' }, { value: '选项3' }],
      required: false,
      width: '',
      optionType: 'static', //  static  dictionary  service
      dicTypeCode: { code: '', name: '', cache: true },
      remoteOptions: [],
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
      },
      remoteUrl: '', // 远端接口地址
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'time',
    name: '时间选择器',
    showName: true,
    icon: 'icon-time',
    options: {
      defaultValue: '',
      readonly: false,
      disabled: false,
      hidden: false,
      editable: false,
      clearable: true,
      startPlaceholder: '',
      endPlaceholder: '',
      isRange: false,
      arrowControl: true,
      format: 'HH:mm:ss',
      required: false,
      width: '100%',
      customClass: '',
      customDesc: '',
      placeholder: '选择时间',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      startTime: '',
      endTime: '',
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'date',
    name: '日期选择器',
    showName: true,
    icon: 'icon-date',
    options: {
      defaultValue: '',
      readonly: false,
      disabled: false,
      hidden: false,
      editable: false,
      clearable: true,
      placeholder: '请选择',
      startPlaceholder: '',
      endPlaceholder: '',
      pickerOptions: null, // 日期配置
      disabledDate: '', // 禁用日期表达式配置
      type: 'date',
      format: 'yyyy-MM-dd',
      timestamp: false,
      required: false,
      arrowControl: true,
      width: '100%',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      startDate: '',
      endDate: '',
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'rate',
    name: '评分',
    showName: true,
    icon: 'icon-icon-test',
    options: {
      defaultValue: 0,
      max: 5,
      disabled: false,
      hidden: false,
      allowHalf: false,
      required: false,
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'color',
    name: '颜色选择器',
    showName: true,
    icon: 'icon-color',
    options: {
      defaultValue: '',
      disabled: false,
      hidden: false,
      showAlpha: false,
      required: false,
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'select',
    name: '下拉选择框',
    showName: true,
    icon: 'icon-select',
    options: {
      defaultValue: '',
      multiple: false,
      disabled: false,
      hidden: false,
      clearable: false,
      placeholder: '请选择',
      required: false,
      showLabel: false,
      excelImportLabel: false, //子表单导入时是否支持标签导入
      width: '100%',
      options: [
        { value: '下拉框1' },
        { value: '下拉框2' },
        { value: '下拉框3' },
      ],
      optionType: 'static', //  static  dictionary  service
      dicTypeCode: { code: '', name: '', cache: true },
      filterable: false,
      remoteOptions: [],
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
      },
      remoteUrl: '',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'switch',
    name: '开关',
    showName: true,
    icon: 'icon-switch',
    options: {
      defaultValue: false,
      required: false,
      disabled: false,
      hidden: false,
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'slider',
    name: '滑块',
    showName: true,
    icon: 'icon-slider',
    options: {
      defaultValue: 0,
      disabled: false,
      required: false,
      hidden: false,
      min: 0,
      max: 100,
      step: 1,
      showInput: false,
      range: false,
      width: '',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'divider',
    name: '分割线',
    showName: false,
    icon: 'icon-icon_bars',
    options: {
      isTextEditor: true, // 是否富文本编辑
      directionValue: 'horizontal',
      contentPositionValue: 'center',
      defaultValue: '分割线',
      showLine: false,
      hidden: false,
      draftOverride: false, // 是否被草稿覆盖
    },
  },
  {
    type: 'swtext',
    name: '文本',
    showName: true,
    icon: 'sw-icon el-icon-info',
    options: {
      isTextEditor: false, // 是否富文本编辑
      width: '100%',
      defaultValue: '',
      hidden: false,
      customClass: '',
      customDesc: '',
      // 初始值
      initialValue: true,
      // optionType: 'service', // static dictionary service
      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
        cascaderVal: [],
        cascadeList: [],
      },
      remoteUrl: '', // 远端接口地址
      isShowSelect: true,
      queryData: {}, // 接口数据详情
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
  {
    type: 'input',
    name: '车牌号输入框',
    labelPosition: '',
    showName: true,
    icon: 'icon-input',
    options: {
      width: '100%',
      length: 50,
      defaultValue: '',
      required: false,
      hidden: false,
      disabled: false,
      customDesc: '',
      // 车牌组件相关配置
      carNumberOptions: {
        isCarNumber: true,
        theme: 'block', // 主题
        boxWidth: 35, // 单个框宽度
        boxHeight: 35, // 单个框高度
        borderRadius: '5px', // 圆角
        boxMargin: 4, // 单个框间隔
        textSize: 18, // 字体大小
        textColor: '#666666', // 字体颜色
        borderColor: '#D9D9D9', // 边框颜色
        selectBorderColor: '#038AFF', // 选中字体框颜色
        backgroundColor: '#FFFFFF', // 背景颜色
        newEnergyColor: '#61c15f', // 新能源颜色
        newEnergyFontSize: 10, // 新能源字体大小
      },
    },
    eventOptions: {
      // 事件选项
      eventType: null,
      eventObj: [], // 内置属性
    },
  },
]

export const advanceComponents = [
  {
    type: 'imgupload',
    name: '图片',
    showName: true,
    icon: 'icon-tupian',
    options: {
      defaultValue: [],
      appId: '', // 所属应用ID
      size: {
        width: 100,
        height: 100,
      },
      width: '',
      disabled: false,
      hidden: false,
      required: false,
      length: 8,
      multiple: false,
      allowableType: '',
      isDelete: false,
      min: 0,
      maxSize: 200,
      // isEdit: false,
      action: '/api/v1/file/service/file-upload/upload',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
  {
    type: 'file',
    name: '附件',
    showName: true,
    icon: 'sw-icon el-icon-folder-opened',
    options: {
      defaultValue: [],
      appId: '', // 所属应用ID
      showType: 'drag', // 上传附件组件展现形式； drag 拖拽框   btn button按钮
      disabled: false,
      allowableType: '', // 允许上传文件类型，当为空时，不限定；多个限定时，以英文逗号分隔
      hidden: false,
      required: false,
      multiple: false,
      length: 8, // 上传文件最大数
      action: '/api/v1/file/service/file-upload/upload',
      maxSize: 200,
      customClass: '',
      customDesc: '',
      sign: false, // 是否附件签章
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      downloadType: 'ordinaryType', //普通下载'ordinaryType'   普通下载和水印下载'allType'    水印下载'watermarkType'
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'editor',
    name: '编辑器',
    showName: true,
    icon: 'icon-fuwenbenkuang',
    options: {
      defaultValue: '',
      disabled: false,
      hidden: false,
      required: false,
      width: '',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'cascader',
    name: '级联选择器',
    showName: true,
    icon: 'icon-jilianxuanze',
    options: {
      defaultValue: [],
      width: '100%',
      placeholder: '请选择',
      disabled: false,
      hidden: false,
      clearable: false,
      required: false,
      multiple: false, // 是否可以多选
      checkStrictly: false, // 是否可以任选一级
      showAllLevels: false, // 是否显示选中值的完整路径
      remoteOptions: [],
      remoteQuery: {
        username: false,
        fromWidget: {
          key: '',
          value: '',
        },
      },
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'value',
        label: 'label',
        children: 'children',
        pk: 'id', // 主键
        ppk: 'pid', // 父主键
        paramFormat: 'data', // 参数格式
      },
      remoteUrl: '',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'button',
    name: '按钮',
    showName: false,
    icon: 'sw-icon el-icon-thumb',
    options: {
      icon: '', // 图标
      height: '',
      width: '',
      disabled: false,
      hidden: false,
      type: 'primary',
      size: 'medium',
      clazz: '', // 按钮 圆角、原型、朴素等
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'sonform',
    name: '子表单',
    showName: false,
    icon: 'sw-icon el-icon-tickets',
    list: [], // 基础结构配置
    sonValues: [], // 子表单具体数据
    lineDetails: [], // 子表单每一行数据详情， 该行是否显示、禁用； 以及该行每个字段 禁用、是否显示
    tableLists: [], // 实际结构配置，二维数组，子表单的每一行配置数据
    options: {
      width: '',
      defaultValue: '',
      disabled: false,
      hidden: false,
      minLines: 1,
      maxLines: 20,
      minWidth: '140px', // 子表单最小列宽
      // 初始值
      initialValue: true,
      // optionType: 'service', // static dictionary service
      props: {
        value: 'value',
        label: 'label',
        paramFormat: 'data',
        cascaderVal: [],
        cascadeList: [],
      },
      importExcel: false, // 是否支持Excel导入
      remoteUrl: '', // 远端接口地址
      queryData: {}, // 接口数据详情
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      prefix: '', // 前缀
      suffix: '', // 后缀
      addBtnName: '新增', // 自定义新增按钮名称
      numberTitle: '序号', // 序号标题
    },
  },
  {
    type: 'location',
    name: '当前位置',
    showName: true,
    icon: 'su-icon-location1',
    options: {
      disabled: false,
      hidden: false,
      required: false,
      placeholder: '搜索周边区域（1000米内）',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
]

export const layoutComponents = [
  {
    type: 'grid',
    name: '栅格布局',
    showName: false,
    icon: 'sw-icon el-icon-menu',
    columns: [
      { span: 12, list: [] },
      { span: 12, list: [] },
    ],
    options: {
      gutter: 0,
      justify: 'start',
      align: 'top',
      customClass: '',
      customDesc: '',
      draftOverrideVisible: false, // 草稿隐藏
    },
  },
  {
    type: 'report',
    icon: 'sw-icon el-icon-s-grid',
    name: '中国式表格',
    showName: true,
    options: {
      customClass: '',
      hidden: false,
      borderWidth: 1,
      borderColor: '#999',
      width: '100%',
      draftOverrideVisible: false, // 草稿隐藏
    },
    rows: [
      {
        columns: [
          {
            type: 'td',
            options: {
              customClass: '',
              colspan: 1,
              rowspan: 1,
              align: 'left',
              valign: 'top',
              width: '',
              height: '',
            },
            list: [],
          },
        ],
      },
    ],
  },
  {
    type: 'page',
    name: '页面组件',
    showName: false,
    icon: 'sw-icon el-icon-reading',
    tableLists: [], // 实际结构配置 ，二维数组
    options: {
      defaultValue: [],
      labelWidth: '0',
      width: '100%',
      selectPage: '', // 选中的子页面
      type: 'multiple', // single 单条记录    multiple  多条记录
      showField: [], // 回显字段
      pageValue: [], // 结果数据
      disabled: false,
      hidden: false,
      required: false,
      minWidth: '140px', // 子表单最小列宽
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
  {
    type: 'comment',
    name: '评阅组件',
    showName: false,
    icon: 'sw-icon el-icon-chat-line-round',
    list: [],
    options: {
      disabled: false,
      showOthersComment: false,
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
  },
]

export const businessComponents = [
  {
    type: 'address',
    name: '地区选择',
    showName: true,
    icon: 'sw-icon el-icon-location-information',
    options: {
      defaultValue: {
        selectValue: [], // 级联下拉选择
        inputValue: '', // 手动输入详细地址
      },
      width: '100%',
      placeholder: '请选择地区',
      placeholder2: '请填写详细地址',
      disabled: false,
      hidden: false,
      required: false,
      clearable: false, // 是否可以清除
      checkStrictly: false, // 任选一层
      isShowDetailInput: false, // 是否显示详细地址输入框
      remoteOptions: [],
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'id',
        label: 'area_name',
        children: 'children',
        pk: 'id',
        ppk: 'pid',
        paramFormat: 'data',
      },
      remoteUrl: '/v1/area/selectAreaList',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: 'change',
      eventObj: [],
    },
  },
  {
    type: 'organization',
    name: '组织机构选择',
    showName: true,
    icon: 'sw-icon el-icon-school',
    options: {
      defaultValue: [],
      width: '100%',
      placeholder: '请选择组织机构',
      disabled: false,
      hidden: false,
      clearable: false,
      required: false,
      multiple: false, // 是否可以多选
      checkStrictly: false, // 是否可以任选一级
      showAllLevels: true, // 是否显示选中值的完整路径
      remoteOptions: [],
      orgRootId: '', // 配置默认组织机构id
      groupId: '', // 配置默认用户组id
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      props: {
        value: 'id',
        label: 'ins_name',
        children: 'children',
        pk: 'id',
        ppk: 'pid',
        paramFormat: 'data',
      },
      remoteUrl: '/v1/institution/selectInsList',
      customClass: '',
      customDesc: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
      initCurOrgCode: '', //初始化当前组织机构
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'user',
    name: '人员选择',
    showName: true,
    icon: 'sw-icon el-icon-user',
    options: {
      defaultValue: [],
      width: '100%',
      placeholder: '请输入工号筛选人员',
      disabled: false,
      hidden: false,
      clearable: false,
      identityTypeIds: '',
      required: false,
      multiple: false, // 是否可以多选
      optionsList: [], // 使用组织机构选择时的选中列表,保证关闭预览再次打开时能够匹配到标题
      // optionsList: null, // 使用组织机构选择时的选中列表,保证关闭预览再次打开时能够匹配到标题
      useOraganization: false, // 是否使用组织机构选择
      orgRootId: '',
      groupId: '', // 配置默认用户组id
      props: {
        value: 'id',
        label: 'ins_name',
        children: 'children',
        pk: 'id',
        ppk: 'pid',
        paramFormat: 'data',
      },
      limit: 30, // 分页数
      timeInterval: 1000, // 搜索输入时间间隔
      customClass: '',
      customDesc: '',
      supportExcel: false,
      supportMobileInit: true,
      usernameKey: 'username',
      templateLink: '',
      // eslint-disable-next-line no-template-curly-in-string
      format: '${xm}-${gh}-${bm}',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      eventType: null,
      eventObj: [],
    },
  },
  {
    type: 'esign',
    name: '电子签名',
    showName: true,
    icon: 'icon-input',
    options: {
      width: '100%',
      defaultValue: '',
      lineWidth: 3,
      required: false,
      hidden: false,
      disabled: false,
      pattern: '',
      isUpdate: true,
      placeholder: '请签名',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {
      // 事件选项
      eventType: null,
      eventObj: [], // 内置属性
    },
  },
]

export const searchComponents = [
  {
    type: 'table',
    name: '表格',
    showName: true,
    icon: 'sw-icon el-icon-s-grid',
    options: {
      optionType: 'service', //  static  dictionary  service
      props: {
        tableTitle: 'tableTitle',
        tableData: 'tableData',
        page: 'page',
        pageSize: 'pageSize',
        paramFormat: 'data',
        total: 'total',
      },
      page: 'page',
      pageSize: 'pageSize',
      total: 1,
      width: '100%',
      remoteOptionsCache: false, // 远程数据缓存，废弃上面的dicTypeCode.cache
      variables: [],
      tableTitle: [
        {
          prop: 'prop1',
          label: 'title1',
        },
        {
          prop: 'prop2',
          label: 'title2',
        },
        {
          prop: 'prop3',
          label: 'title3',
        },
      ],
      tableData: [
        {
          prop1: 'value1',
          prop2: 'value2',
          prop3: 'value3',
        },
        {
          prop1: 'value1',
          prop2: 'value2',
          prop3: 'value3',
        },
        {
          prop1: 'value1',
          prop2: 'value2',
          prop3: 'value3',
        },
      ],
      remoteUrl: '',
      draftOverride: false, // 是否被草稿覆盖
      draftOverrideVisible: true, // 草稿是否显示<子表单内隐藏>
    },
    eventOptions: {},
  },
]
